"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.uuid = void 0;
function uuid() {
    return (Math.random()
        .toString(36)
        .substring(2) + (+new Date()).toString(36)).substring(0, 12);
}
exports.uuid = uuid;
//# sourceMappingURL=uuid.js.map